var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4118 12L20.529 6.88278C21.157 6.25483 21.157 5.2367 20.529 4.60824L19.3918 3.47097C18.7638 2.84301 17.7457 2.84301 17.1172 3.47097L12 8.58818L6.88278 3.47097C6.25483 2.84301 5.2367 2.84301 4.60824 3.47097L3.47097 4.60824C2.84301 5.23619 2.84301 6.25432 3.47097 6.88278L8.58818 12L3.47097 17.1172C2.84301 17.7452 2.84301 18.7633 3.47097 19.3918L4.60824 20.529C5.23619 21.157 6.25483 21.157 6.88278 20.529L12 15.4118L17.1172 20.529C17.7452 21.157 18.7638 21.157 19.3918 20.529L20.529 19.3918C21.157 18.7638 21.157 17.7457 20.529 17.1172L15.4118 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.dfa2cc1150e061536bada7574f2504c1.svg";
export { ForwardRef as ReactComponent };